<template>
  <div class="chips-skeleton">
    <base-skeleton width="20%" height="46px" border-radius="10px" />
    <base-skeleton width="20%" height="46px" border-radius="10px" />
    <base-skeleton width="20%" height="46px" border-radius="10px" />
    <base-skeleton width="20%" height="46px" border-radius="10px" />
    <base-skeleton width="20%" height="46px" border-radius="10px" />
  </div>
</template>

<script>
import BaseSkeleton from '@/shared/ui/BaseSkeleton/BaseSkeleton.vue'

export default {
  components: {
    BaseSkeleton,
  },
}
</script>

<style scoped lang="scss">
.chips-skeleton {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  margin-top: 10px;
}
</style>
